import {
  AddSharp,
  EditSharp,
  FileDownload,
  HistorySharp,
  RefreshSharp
} from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from "@mui/material";
import MaterialReactTable from "material-react-table";
import { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import axios from "../../axiosInstances";
import { ShoppingCartContext } from "../Context/ShoppingCartContext";
import ChartOfAccountModel from "./ChartOfAccountModel";

import { useTheme } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";



function ChartOfAccountComp(props) {
  const navigate = useNavigate();
  const theme = useTheme();
  const [update, setUpdate] = useState(false);
  const location = useLocation();
  const { setPageHeader, globalUser, globalCustomers, globalProviders, globalToken } = useContext(ShoppingCartContext);
  const { t, i18n } = useTranslation();
  const [chartOfAccountsList, setChartOfAccountsList] = useState([]);
  const [groupSum, setGroupSum] = useState([]);
  const localeStringOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  const columns = useMemo(
    () => [
      {
        header: "Account",
        accessorKey: "Account",
        size: 120
      },
      {
        header: "Description",
        accessorKey: "Description",
      },
      {
        header: "Type",
        accessorKey: "Type",
        size: 100
      },

      {
        header: "Category",
        accessorKey: "Category",

      },

      {
        header: "Debit",
        accessorKey: "Debit",
        aggregationFn: 'sum',
        AggregatedCell: ({ cell }) => <div>{cell.getValue()?.toLocaleString?.('en-US', localeStringOptions)}</div>,
      },
      {
        header: "Credit",
        accessorKey: "Credit",
        aggregationFn: 'sum',
        AggregatedCell: ({ cell }) => <div>{cell.getValue()?.toLocaleString?.('en-US', localeStringOptions)}</div>,
      },

      {
        header: "Remark",
        accessorKey: "Remark",

      },

    ],
    []
  );

  const loadPaymentList = () => {
    axios.get("/chartofaccounts/getByParent?Parent=" + globalUser.Parent, {
      headers: {
        token: globalToken,
      },
    })
      .then(response => {
        if (response.data.data) {
          setChartOfAccountsList(response.data.data);
        } else {
          alert('log out and log in again')
        }
      })

  };

  const handleUploadFile = async (e) => {
    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    var jsonData = XLSX.utils.sheet_to_json(worksheet);

    var fdata = new FormData();
    fdata.append("JsonData", JSON.stringify(jsonData));
    await axios.post("/items/Excel", fdata, {
      headers: {
        token: globalToken,
      },
    });
  };
  function handleDownloadFile() {
    const worksheet = XLSX.utils.json_to_sheet(chartOfAccountsList);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "stores");
    //let buf = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, "storesdata.xlsx");
  }

  useEffect(() => {
    if (!globalUser) {
      navigate('/');
      return;
    }
    setPageHeader("Chart of Accounts");

    loadPaymentList();

  }, [update]);
  return (

    <Grid container>

      <Grid item className="hideInMobile" m={1}>

        <MaterialReactTable
          columns={columns}
          data={chartOfAccountsList}
          initialState={{ density: "compact", pagination: { pageIndex: 0, pageSize: 20 }, grouping: ['Category'] }}
          enableGlobalFilter
          enableColumnOrdering
          enableColumnResizing
          enableColumnFilters
          enableGrouping
          //enableRowNumbers
          muiTopToolbarProps={{
            sx: { backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText }
          }}
          muiBottomToolbarProps={{
            sx: { backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText }
          }}
          renderTopToolbarCustomActions={() => (
            <Box>
              <Button size="small"
                variant="standard" sx={{ borderRadius: '30px' }} endIcon={<AddSharp style={{ width: "20px", height: "20px" }} />}>
                <ChartOfAccountModel
                  icon={
                    <div>Add</div>
                  }
                  data=""
                  Type={location.state.Type}
                  ParentUpdate={update}
                  setParentUpdate={setUpdate}

                />
              </Button>|


              <Button size="small"
                variant="standard" sx={{ borderRadius: '30px' }} endIcon={<FileDownload style={{ width: "20px", height: "20px" }} />} type="file" onClick={handleDownloadFile}>
                Download
              </Button>|
              <Tooltip title="refresh">
                <Button size="small"
                  variant="standard" sx={{ borderRadius: '30px' }} endIcon={<RefreshSharp />} onClick={() => setUpdate(!update)}>
                  Refresh
                </Button>
              </Tooltip>|


            </Box>
          )}
          enableRowActions
          renderRowActions={(table) => (
            <Box>
              <Tooltip title={t("Edit")}>
                <IconButton >

                  <ChartOfAccountModel
                    icon={<EditSharp style={{ width: "20px", height: "20px" }} />}
                    data={table.row.original}


                    ParentUpdate={update}
                    setParentUpdate={setUpdate}

                  />
                </IconButton>
              </Tooltip>|
              <Tooltip title={t("Entries")}>
                <IconButton >

                  <ChartOfAccountModel
                    icon={<HistorySharp style={{ width: "20px", height: "20px" }} />}
                    data={table.row.original}


                    ParentUpdate={update}
                    setParentUpdate={setUpdate}

                  />
                </IconButton>
              </Tooltip>
            </Box>
          )}
        ></MaterialReactTable>
      </Grid>
      <Grid item xs={12} mt={2} className="hideInFull">
        <Box sx={{ width: "100%", backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText }}>
          <Button size="small"
            variant="standard" sx={{ borderRadius: '30px' }} endIcon={<AddSharp style={{ width: "20px", height: "20px" }} />}>
            <ChartOfAccountModel
              icon={
                <div>Add</div>
              }
              data=""
            />
          </Button>|
          {/*    <Button size="small"
                    variant="standard" sx={{borderRadius:'30px'}} endIcon={<FileUpload style={{ width: "20px", height: "20px" }} />}>
                    <label htmlFor="file">
                      Upload
                    </label>
                    <input
                      id="file"
                      name="file"
                      hidden
                      type="file"
                      onChange={handleUploadFile}
                    />
                  </Button>| */}

          <Button size="small"
            variant="standard" sx={{ borderRadius: '30px' }} endIcon={<FileDownload style={{ width: "20px", height: "20px" }} />} type="file" onClick={handleDownloadFile}>
            Download
          </Button>|
          <Tooltip title="refresh">
            <Button size="small"
              variant="standard" sx={{ borderRadius: '30px' }} endIcon={<RefreshSharp />} onClick={() => setUpdate(!update)}>
              Refresh
            </Button>
          </Tooltip>
        </Box>
      </Grid>
      {!(chartOfAccountsList === undefined) &&
        chartOfAccountsList.length > 0 &&
        chartOfAccountsList.map((item) => {
          return (
            <Grid item key={item.Id} xs={5} m={2} className="hideInFull">
              <Card sx={{ borderRadius: 10, boxShadow: 3, width: "100%" }} >
                <CardHeader
                  title={"Acc. No: " + item.Account}
                  subheader={'Doc. No: ' + item.Description}

                />

                <CardContent>
                  <Typography variant="body2" align="left">
                    Type: {item.Type}
                  </Typography>
                  <Typography variant="body2" align="left">
                    Category: {item.Category}
                  </Typography>
                  <Typography variant="body2" align="left">
                    Amount: {item?.Amount}
                  </Typography>
                  <Typography variant="body2" align="left">
                    Direct Posting: {item?.DirectPosting}
                  </Typography>
                  <Typography variant="body2" align="left">
                    Remark: {item.Remark}
                  </Typography>
                </CardContent>
                <CardActions
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                  }} >
                  <Box>
                    <Tooltip title={t("Edit Store")}>
                      <IconButton >

                        <ChartOfAccountModel
                          icon={<EditSharp style={{ width: "20px", height: "20px" }} />}
                          data={item}

                          ParentUpdate={update}
                          setParentUpdate={setUpdate}
                          Type="GJ"


                        />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </CardActions>
              </Card>
            </Grid>
          );
        })}
    </Grid>

  );
}

export default ChartOfAccountComp;